var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor ai-call" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Agent ID")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mode-switch" },
          [
            _c(
              "a-radio-group",
              {
                attrs: { "button-style": "solid", size: "small" },
                model: {
                  value: _vm.agentIdMode,
                  callback: function ($$v) {
                    _vm.agentIdMode = $$v
                  },
                  expression: "agentIdMode",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "static" } }, [
                  _vm._v("Statik"),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "dynamic" } }, [
                  _vm._v("Dinamik"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.agentIdMode === "static"
          ? _c(
              "div",
              { staticClass: "dropdown-wrapper" },
              [
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "Agent seçiniz",
                      loading: _vm.loadingAgents,
                      allowClear: "",
                    },
                    on: { focus: _vm.loadAgents },
                    model: {
                      value: _vm.clone.agentId,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "agentId", $$v)
                      },
                      expression: "clone.agentId",
                    },
                  },
                  _vm._l(_vm.agents, function (agent) {
                    return _c(
                      "a-select-option",
                      { key: agent.agent_id, attrs: { value: agent.agent_id } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(agent.agent_name) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "text-editor-wrapper" },
              [
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: "Agent ID girin veya attribute kullanın",
                    "show-attributes": true,
                    "show-emoji": false,
                    "max-character-count": 100,
                    "automation-mode": "",
                  },
                  model: {
                    value: _vm.clone.agentId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "agentId", $$v)
                    },
                    expression: "clone.agentId",
                  },
                }),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Arayan Numara")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mode-switch" },
          [
            _c(
              "a-radio-group",
              {
                attrs: { "button-style": "solid", size: "small" },
                model: {
                  value: _vm.fromNumberMode,
                  callback: function ($$v) {
                    _vm.fromNumberMode = $$v
                  },
                  expression: "fromNumberMode",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "static" } }, [
                  _vm._v("Statik"),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "dynamic" } }, [
                  _vm._v("Dinamik"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.fromNumberMode === "static"
          ? _c(
              "div",
              { staticClass: "dropdown-wrapper" },
              [
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "Arayan numara seçiniz",
                      loading: _vm.loadingNumbers,
                      allowClear: "",
                    },
                    on: { focus: _vm.loadNumbers },
                    model: {
                      value: _vm.clone.fromNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "fromNumber", $$v)
                      },
                      expression: "clone.fromNumber",
                    },
                  },
                  _vm._l(_vm.phoneNumbers, function (number) {
                    return _c(
                      "a-select-option",
                      {
                        key: number.phone_number,
                        attrs: { value: number.phone_number },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              number.nickname ||
                                number.phone_number_pretty ||
                                number.phone_number
                            ) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "text-editor-wrapper" },
              [
                _c("TiptapEditor", {
                  attrs: {
                    placeholder:
                      "E.164 formatında arayan numara girin (örn: +905551234567) veya attribute kullanın",
                    "show-attributes": true,
                    "show-emoji": false,
                    "max-character-count": 50,
                    "automation-mode": "",
                  },
                  model: {
                    value: _vm.clone.fromNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "fromNumber", $$v)
                    },
                    expression: "clone.fromNumber",
                  },
                }),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Aranan Numara")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder:
                  "E.164 formatında aranan numara girin (örn: +905551234567) veya attribute kullanın",
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 50,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.toNumber,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "toNumber", $$v)
                },
                expression: "clone.toNumber",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v("Çağrı Bitene Kadar Bekle"),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.waitForCallEnd,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "waitForCallEnd", $$v)
              },
              expression: "clone.waitForCallEnd",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v("İlgili Kişi ID (opsiyonel)"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "İlgili kişi seçiniz",
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 50,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.contactId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "contactId", $$v)
                },
                expression: "clone.contactId",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Değişkenler")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "variables-container" },
          [
            _c(
              "a-form",
              { attrs: { layout: "vertical" } },
              _vm._l(_vm.variableList, function (variable, index) {
                return _c(
                  "a-form-item",
                  {
                    key: index,
                    attrs: {
                      label: variable.key
                        ? variable.key
                        : "Değişken " + (index + 1),
                    },
                  },
                  [
                    _c("div", { staticClass: "variable-row" }, [
                      _c(
                        "div",
                        { staticClass: "variable-key" },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "Değişken adı" },
                            on: { change: _vm.updateVariables },
                            model: {
                              value: variable.key,
                              callback: function ($$v) {
                                _vm.$set(variable, "key", $$v)
                              },
                              expression: "variable.key",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "variable-value" },
                        [
                          _c("TiptapEditor", {
                            attrs: {
                              placeholder: "Değişken değeri veya attribute",
                              "show-attributes": true,
                              "show-emoji": false,
                              "max-character-count": 200,
                              "automation-mode": "",
                            },
                            on: { input: _vm.updateVariables },
                            model: {
                              value: variable.value,
                              callback: function ($$v) {
                                _vm.$set(variable, "value", $$v)
                              },
                              expression: "variable.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "variable-actions" },
                        [
                          _c("a-button", {
                            attrs: {
                              type: "danger",
                              shape: "circle",
                              icon: "delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeVariable(index)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-variable" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "dashed", block: "" },
                    on: { click: _vm.addVariable },
                  },
                  [
                    _c("a-icon", { attrs: { type: "plus" } }),
                    _vm._v(" Değişken Ekle\n                    "),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }